import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const notificationManagementRouter = [
  {
    path: 'notifications',
    component: () => import('@/features/notificationManagement/NotificationManagementLayout.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.NoticesView,
    },
    children: [
      {
        path: '',
        component: () => import('@/features/notificationManagement/NotificationManagementMain.vue'),
        meta: { permissionAction: PermissionActions.NoticesView },
      },
      {
        path: 'setup',
        component: () => import('@/features/notificationManagement/setup/NotificationSetup.vue'),
        meta: { permissionAction: PermissionActions.NoticesSetupView },
      },
      {
        path: 'create',
        component: () => import('@/features/notificationManagement/create/NotificationCreate.vue'),
        meta: { permissionAction: PermissionActions.NoticesCreate },
      },
      {
        path: 'sent',
        component: () =>
          import('@/features/notificationManagement/announcements/NotificationManagementAnnouncementsList.vue'),
        meta: { permissionAction: PermissionActions.NoticesHistoryView },
      },
      {
        path: 'sent/:announcementId',
        component: () =>
          import('@/features/notificationManagement/announcements/NotificationManagementAnnouncementsDetail.vue'),
        meta: { permissionAction: PermissionActions.NoticesHistoryView },
      },
    ],
  },
]
